import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { AdminService } from '../../../shared/services/admin.service';

import { ToastrService } from 'ngx-toastr';
import { SharedAuthService } from '../../../shared/shared.auth.service';
import { environment } from '../../../../environments/environment';
import { MatTabGroup, MatTab } from '@angular/material/tabs';
import { MatFormField, MatLabel, MatSelect, MatOption } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MaintenanceTableV4Component } from '../maintenance-table-v4/maintenance-table-v4.component';

@Component({
    selector: 'app-rules-engine',
    templateUrl: './rules-engine.component.html',
    styleUrl: './rules-engine.component.css',
    imports: [MatTabGroup, MatTab, MatFormField, MatLabel, MatSelect, FormsModule, MatOption, MatButton, MaintenanceTableV4Component]
})
export class RulesEngineComponent implements OnInit {
  rule_displayedColumns: string[] = ['ruleId', 'ruleName','ruleDescription', 'ruleType','triggerTable', 'triggerColumn', 'active'];
  rule_col = [
    {
      key: 'ruleId',
      label: 'Rule Id',
      width: '9% !important',
    },
    {
      key: 'ruleName',
      label: 'Rule Name',
      width: '10% !important',
    },
    {
      key: 'ruleDescription',
      label: 'Rule Description',
      width: '30% !important',
    },
    {
      key: 'ruleType',
      label: 'Rule Type',
      width: '9% !important',
    },
    {
      key: 'triggerTable',
      label: 'Trigger Table',
      width: '9% !important',
    },
    {
      key: 'triggerColumn',
      label: 'Trigger Column',
      width: '9% !important',
    },
    {
      key: 'ruleScore',
      label: 'Rule Score',
      width: '6% !important',
    },
    {
      key: 'active',
      label: 'Active',
      isSort: true,
      width: '9% !important',
    },
    {
      key: 'Actions',
      label: 'Information',
      width: '3% !important',
      align: 'center !important',
      padding: '0 1rem 0 0 !important',
    }
  ];
  TABLE_CONFIG: any = {
    pageSize: [10, 20, 40],
    pageIndex: 0,
    totalItems: 0,
    selection: false,
    edit: false,
    serverSidePagination: false,
    deleteFeature: true,
    expandable: false,
    ruleInfo: true,
  };
  rule_dataSource: MatTableDataSource<any>;
  tableList: any[];
  selectedTable: any;
  originalRuleData: any;
  disableValidateBtn:boolean = true;
  rulesEngineVisibility:boolean = false;
  constructor(public admnsrv: AdminService, public toaster: ToastrService, private sharedAuthService:SharedAuthService) { }

  ngOnInit() {
    this.getRulesData();
    this.rulesEngineVisibility = this.sharedAuthService.getRulesEngineVisibility();
  }
  getRulesData() {
    this.admnsrv.getRules().subscribe((res: any) => {
      if (res && res.length > 0) {
        this.originalRuleData = res; // Store original data for filtering
        this.rule_dataSource = new MatTableDataSource(res);
        this.tableList = Array.from(new Set(res.map((rule: any) => rule.triggerTable)));
        this.tableList.unshift('All');
        this.selectedTable = 'All';
        this.TABLE_CONFIG.totalItems = res.length;
        this.disableValidateBtn = (this.selectedTable == 'All') || (res.length === 0);
      }
    }
    );
  }

  editRules(event: any) {
    console.log('Edit Rules Event:', event);
  }

  validateData(){
     let userDtls = {
      'cn':this.sharedAuthService.getMsid(),
      'mail': JSON.parse(sessionStorage.getItem('loggedInUserEmail') )|| '',
      'currentUser': JSON.parse(sessionStorage.getItem('currentUser'))|| ''
    }
    if(environment.environmentName && environment.environmentName.toLowerCase() == 'uat'){
      userDtls['environment'] = environment.environmentName;
    }

    this.admnsrv.validateExsistingData(this.selectedTable,userDtls).subscribe((res: any) => {
     this.toaster.success(
      'Thank you for submitting the request. You will be notified via email on status',
      '',
      { positionClass: 'toast-top-center', timeOut: 2000 }
    );
    }
    );
  }
  tableNameChange(){
    if(this.selectedTable === 'All'){
      this.rule_dataSource = new MatTableDataSource(this.originalRuleData || []);
      this.disableValidateBtn = true;
      this.TABLE_CONFIG.totalItems = this.originalRuleData.length;
      return;
    }
    let filteredData = this.originalRuleData.filter((rule: any) => rule.triggerTable === this.selectedTable);
    this.rule_dataSource = new MatTableDataSource(filteredData || []);
    this.disableValidateBtn = filteredData.length === 0;
    this.TABLE_CONFIG.totalItems = filteredData.length;
  }

}
